import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";

import { user } from "./PatientBasicInfo.type";
import LavorisService from "../../../services/LavorisService";
import { GetOneAppointmentResponseService, Patient } from "../../../services/TurnServices/Turns.type";
import { GetIndividualApplicant } from "../../../services/Company/Applicant.type";
import { GetParticularPatientProfileResponseService } from "../../../services/ParticularPatient/ParticularPatient.type";
import { IndividualEmployeeResponseService } from "../../../services/Company/Employee.type";
import { useFetchOne } from "../../../hooks";
import StyledWrapper from "./style";

export type PatientBasicInfoProps = {
  patient?: Patient;
};


export default function PatientBasicInfo({ patient }: PatientBasicInfoProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const LavorisInstance = LavorisService.getInstance();
  const rowData = useFetchOne<GetOneAppointmentResponseService>("appointments");
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (!rowData) return
  }, [searchParams])


  return (
    <>
      <div className="flex gap-10 items-center bg-[#F8F7F7] rounded-lg p-4">
        <div className="relative flex items-center justify-center w-20 h-20 ml-8 bg-white rounded-full shadow-xl">
          <img src="/images/Profile.svg" alt="" />
          <div className="absolute bottom-0 right-0">
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            />
          </div>
        </div>
        <div>
          <p>
            <StyledWrapper.ListItemCard>Nombre:</StyledWrapper.ListItemCard>
            {rowData?.patient?.name || "---"}
          </p>
          <p>
            <StyledWrapper.ListItemCard>DNI:</StyledWrapper.ListItemCard>
            {rowData?.patient?.DNI || "---"}
          </p>
          {/* <p>
              <StyledWrapper.ListItemCard>Cliente:</StyledWrapper.ListItemCard>
              {rowData?.patient?.company?.socialReason ||
                rowData?.patient?.company?.branchOfficeName ||
                "Cliente particular"}
            </p> */}
          <p>
            <StyledWrapper.ListItemCard>
              Fecha de Nacimiento:
            </StyledWrapper.ListItemCard>
            {rowData?.patient?.birthDate || "---"}
          </p>
          <p>
            <StyledWrapper.ListItemCard>Puesto:</StyledWrapper.ListItemCard>
            {rowData?.patient?.positionName || "Cliente particular"}
          </p>
        </div>
      </div>

      <div className="w-full border-t border-gray-300 mt-6 mb-10"></div>
    </>
  );
}
